var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.723,
    height: 41.031,
    viewBox: "0 0 29.723 41.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    transform: "translate(4134.002 19486.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_974",
    "data-name": "Rectangle 974",
    width: 18,
    height: 20,
    transform: "translate(-4127 -19482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(7 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M14.862,41.031a1.339,1.339,0,0,1-.993-.443A89.307,89.307,0,0,1,6.721,31.3a55.506,55.506,0,0,1-4.634-8.221A20.988,20.988,0,0,1,0,14.855a14.861,14.861,0,0,1,29.722,0,20.989,20.989,0,0,1-2.087,8.222A55.527,55.527,0,0,1,23,31.3a90.991,90.991,0,0,1-7.143,9.289A1.361,1.361,0,0,1,14.862,41.031ZM12.61,17.847H17.6L18.622,21h3.131L16.989,7.18H13.225L8.454,21h3.131l1.025-3.15Zm4.251-2.281H13.352l1.7-5.229h.108l1.7,5.228Z",
    transform: "translate(-4141.002 -19484.998)",
    fill: "#15198f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinStart);
export default __webpack_public_path__ + "static/media/pinStart.983da2e60d6df1602e3662081b13b531.svg";
export { ForwardRef as ReactComponent };